export default "/app/global-wrapper-client/static/5435908c2cd346b31a56d3ee536eacff.woff";